import { trace } from 'owa-trace';
/* List to store the item ids to get the Coupon information */
var couponPeekItemIdMap = {}; // Map<mailboxId, ItemId[]>
/**
 * Add an item id to the coupon peek item id map
 * @param mailboxId the mailbox id of the user
 * @param itemId the item id to be fetched
 */
export var add = function addToCouponPeekItemIdMap(mailboxId, itemId) {
    if (contains(mailboxId, itemId)) {
        trace.warn('couponPeekOperations: duplicate itemId should not be fetched again');
        return;
    }
    var itemIds = couponPeekItemIdMap[mailboxId];
    if (itemIds) {
        couponPeekItemIdMap[mailboxId].push(itemId);
    }
    else {
        couponPeekItemIdMap[mailboxId] = [itemId];
    }
};
/**
 * Whether an item is already added to the fetch list of the mailbox
 * @param mailboxId the mailbox id of the user
 * @param itemId the item id to be fetched
 * @returns true if an item is already added to the fetch list, false otherwise
 */
export var contains = function containsInCouponPeekItemIdMap(mailboxId, itemId) {
    var itemIdsToFetch = couponPeekItemIdMap[mailboxId];
    return itemIdsToFetch && itemIdsToFetch.indexOf(itemId) > 0;
};
/**
 * Remove the coupon fetch list of the specified user mailbox
 * @param mailboxId the mailbox id of the user
 */
export var removeFetchList = function removeFetchListForMailbox(mailboxId) {
    delete couponPeekItemIdMap[mailboxId];
};
/**
 * Get the coupon fetch list of the specified user mailbox
 * @param mailboxId the mailbox id of the user
 * @return an array of item ids that to be fetched for coupon information
 */
export var getFetchList = function getFetchListForMailbox(mailboxId) {
    return couponPeekItemIdMap[mailboxId];
};
//# sourceMappingURL=couponPeekMapOperations.js.map